import React, { useState } from 'react';
import '../styles/Header.css';
import Logo from '../assets/ispatec_logo.png';
import { Link } from 'react-router-dom';


const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);


  return (
    <header className="site-header">
      <div className="logo">
        <img src={Logo} alt="Logo ISPATEC" className="logo-img" />
      </div>

      <div className={`nav-links ${menuOpen ? 'open' : ''}`}>
        <a href="#how" onClick={() => setMenuOpen(false)}>Comment ça marche</a>
        <a href="#demande" onClick={() => setMenuOpen(false)}>S'inscrire</a>
        <Link to="/login" className="login-btn" onClick={() => setMenuOpen(false)}>Connexion</Link>
      </div>

      <div className="burger" onClick={toggleMenu}>
        <span className={menuOpen ? 'bar rotate-top' : 'bar'}></span>
        <span className={menuOpen ? 'bar fade-out' : 'bar'}></span>
        <span className={menuOpen ? 'bar rotate-bottom' : 'bar'}></span>
      </div>
    </header>
  );
};

export default Header;
